import DescuentosCaptahuella from "./descuentosCaptahuella";

export default DescuentosCaptahuella;

